// src/pages/AccountDeletionPage.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, ExternalLink } from 'lucide-react';

const AccountDeletionPage = () => {
  const { t } = useTranslation();
  const [redirecting, setRedirecting] = useState(false);

  const handleRedirectToApp = () => {
    setRedirecting(true);
    setTimeout(() => {
      window.location.href = 'https://bible4.me/app/#/profile';
    }, 500);
  };

  return (
    <div className="flex flex-col items-center min-h-screen bg-amber-100 p-4">
      <div className="w-full max-w-md">
        <header className="bg-amber-200 p-4 rounded-t-lg">
          <h1 className="text-xl font-bold text-amber-900 text-center">Bible4Me</h1>
        </header>

        <main className="bg-white rounded-b-lg p-6 shadow-md">
          <h2 className="text-xl font-bold text-amber-900 mb-4 text-center">
            {t('deleteAccount.title')}
          </h2>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <AlertTriangle className="h-6 w-6 text-amber-900 flex-shrink-0 mt-1" />
              <p className="text-amber-900">
                {t('deleteAccount.warning')}
              </p>
            </div>
          </div>

          <h3 className="font-semibold text-amber-900 mb-2">{t('deleteAccount.dataRemoved')}</h3>
          <ul className="list-disc pl-5 mb-6 text-amber-800 space-y-1">
            <li>{t('deleteAccount.bibleNotes')}</li>
            <li>{t('deleteAccount.preferences')}</li>
            <li>{t('deleteAccount.accountInfo')}</li>
          </ul>

          <h3 className="font-semibold text-amber-900 mb-2">{t('deleteAccount.howTo')}</h3>
          <ol className="list-decimal pl-5 mb-6 text-amber-800 space-y-1">
            <li>{t('deleteAccount.step1')}</li>
            <li>{t('deleteAccount.step2')}</li>
            <li>{t('deleteAccount.step3')}</li>
          </ol>

          <button
            onClick={handleRedirectToApp}
            disabled={redirecting}
            className={`w-full py-3 rounded-lg text-white font-medium ${
              redirecting
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-amber-900 hover:bg-amber-800'
            } flex items-center justify-center`}
          >
            {redirecting ? (
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                {t('deleteAccount.openingApp')}
              </div>
            ) : (
              <div className="flex items-center">
                {t('deleteAccount.openApp')}
                <ExternalLink size={16} className="ml-2" />
              </div>
            )}
          </button>
        </main>
      </div>
    </div>
  );
};

export default AccountDeletionPage;
